import { useEffect, useState } from 'react';
import {
  fmesh,
  fullmesh,
  fmeshPoints
} from './globalVariables.js';
import harrierPolygonLayer from './harrierPolygonLayer.js';

const ResetMap = async (globalRefs, globalState, onComplete) => {
  let mapRef = globalRefs.mapRef;
  let drawRef = globalRefs.drawRef;
  let polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
  let longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
  let selectedYearEditing = globalState.selectedYearEditing;
  let isDrawing = globalState.isDrawing;
  let centroidRef = globalRefs.centroidRef;
  let universalParcelDifferentiator = globalState.universalParcelDifferentiator;
  let universalColorPaletteName = globalState.universalColorPaletteName;
  let landKeySelectedKey = globalState.landKeySelectedKey;
  let selectedMetric = globalState.selectedMetric;
  let selectedKey = globalState.selectedKey;
  let multuGroupSelectedArray = globalState.multuGroupSelectedArray;
  let featureList = globalState.featureList;
  let activeFeatureId = globalState.activeFeatureId;
  let setGlobalPolygonTransparency = globalState.setGlobalPolygonTransparency;
  let is2DViewActive = globalState.is2DViewActive;

  let setIsLoading = globalState.setIsLoading;

  if (isDrawing) {
    mapRef.current.removeControl(drawRef.current);
  }
  fmesh.children.forEach((child) => {
    child.geometry.dispose();
    child.material.dispose();
  });
  fmeshPoints.children.forEach((child) => {
    child.geometry.dispose();
    child.material.dispose();
  });
  fullmesh.children.forEach((child) => {
    fullmesh.remove(child);
  });
  fmesh.children.forEach((child) => {
    fmesh.remove(child);
  });
  fmeshPoints.children.forEach((child) => {
    fmeshPoints.remove(child);
  });
  fmesh.children.length = 0;
  fmeshPoints.children.length = 0;
  fullmesh.children.length = 0;
  const map = mapRef.current;
  if (map?.getLayer('Polygons')) {
    map.removeLayer('Polygons');
  }
  if (map?.getSource('Polygons')) {
    map.removeSource('Polygons');
  }
  polygonCustomLayerRef.current = new harrierPolygonLayer(
    'Polygons',
    centroidRef.current.geometry.coordinates[1],
    centroidRef.current.geometry.coordinates[0],
    longstandingGeoJSONRef.current,
    globalRefs,
    globalState,
    universalColorPaletteName,
    universalParcelDifferentiator,
  );
  mapRef.current.addLayer(polygonCustomLayerRef.current);
  polygonCustomLayerRef.current.getRandomPolygonColor(landKeySelectedKey);

  if (fmesh && multuGroupSelectedArray.length > 0) {
    multuGroupSelectedArray.forEach(skylarkId => {
      const feature = longstandingGeoJSONRef?.current?.features?.find(
        f => f.skylark_id === skylarkId
      );
    });
    polygonCustomLayerRef.current.removeFeatureOpacities(
      fmesh,
      multuGroupSelectedArray
    );
  }
}

export default ResetMap;